import type { LOYALTY_CONTEXT, LOYALTY_POSITION } from '@/app/common/starTrack/events/utils/eventsUtils.ts';
import {
  LOYALTY_BANNER_TYPE,
  LOYALTY_CONTENT,
  LOYALTY_LABEL,
} from '@/app/common/starTrack/events/utils/eventsUtils.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { getUserLoyaltyTier, isLoyaltyUser } from '@/app/common/Loyalty/utils.ts';

export const LOYALTY_BANNER_SHOWN = 'LOYALTY_BANNER_SHOWN';
export const LOYALTY_BANNER_SHOWN_VERSION = '2.0';

export type LoyaltyBannerShownPayload = {
  searchId: string;
  context: LOYALTY_CONTEXT;
  type: LOYALTY_BANNER_TYPE;
  label: string;
  domain: string;
  brand: string;
  market: string;
  language: string;
  content: LOYALTY_CONTENT;
  position: LOYALTY_POSITION;
  page: LOYALTY_CONTEXT;
  loggedIn: boolean;
  userLoyaltyEnrol: boolean;
  loyaltyTier: number | null; // ex:  1, 2, 3
};

export type LoyaltyBannerShownParams = {
  searchId: string;
  context: LOYALTY_CONTEXT;
  position: LOYALTY_POSITION;
  isLoggedIn: boolean;
  localization: Localization;
  commonData: CommonData;
};
export const createLoyaltyBannerShownPayload = ({
  searchId,
  context,
  position,
  isLoggedIn,
  localization,
  commonData,
}: LoyaltyBannerShownParams): LoyaltyBannerShownPayload => {
  const { hostname: domain, brand, country, lang } = localization;
  const userLoyaltyEnrol = isLoyaltyUser(commonData);
  const type = isLoggedIn
    ? userLoyaltyEnrol
      ? LOYALTY_BANNER_TYPE.LOGGED_WITH_LOYALTY
      : LOYALTY_BANNER_TYPE.LOGGED_NO_LOYALTY
    : LOYALTY_BANNER_TYPE.NOT_LOGGED;
  const loyaltyTier = getUserLoyaltyTier(commonData);

  return {
    searchId,
    context,
    type,
    label: LOYALTY_LABEL,
    domain,
    brand,
    market: country,
    language: lang,
    content: userLoyaltyEnrol ? LOYALTY_CONTENT.DISCOUNT : LOYALTY_CONTENT.SIGNUP,
    position,
    page: context,
    loggedIn: isLoggedIn,
    userLoyaltyEnrol,
    loyaltyTier,
  };
};
